var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderMinus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M448 96H275.883L226.746 50.746C214.742 38.742 198.465 32 181.492 32H64C28.656 32 0 60.656 0 96V416C0 451.344 28.656 480 64 480H448C483.344 480 512 451.344 512 416V160C512 124.656 483.344 96 448 96ZM464 416C464 424.824 456.82 432 448 432H64C55.18 432 48 424.824 48 416V96C48 87.176 55.18 80 64 80H181.492C185.766 80 189.781 81.664 192.805 84.688L256 144H448C456.82 144 464 151.176 464 160V416ZM336 264.002H176C162.738 264.002 152 274.742 152 288C152 301.256 162.73 311.998 176 311.998H336C349.262 311.998 360 301.258 360 288S349.262 264.002 336 264.002Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderMinus);
export default __webpack_public_path__ + "static/media/folder-minus.70163f62da3f6f7ea35991f0bf95c2e0.svg";
export { ForwardRef as ReactComponent };